import { For, Match, Show, Switch, createMemo } from "solid-js";
import Flexbox from '../../st-flexbox/st-flexbox'
import Icon from "../../st-icon/st-icon";
import { requireWizardContext } from "../WizardContext";
import btnStyles from '../../st-button/st-button.module.css';

export function ControlPanel() {
    const ctx = requireWizardContext();
    const currentStep = createMemo(() => ctx.steps()[ctx.currStep()]);

    return <Flexbox padded dir="horizontal">
        <Flexbox.Item>
            <Flexbox as="button" dir="horizontal" disabled={!ctx.hasPreviousStep()} class={btnStyles.btn} data-type="default" onClick={() => ctx.selectPrevStep()} >
                <Icon src="fas fa-chevron-left" />
                <span>Previous</span>
            </Flexbox>
        </Flexbox.Item>
        <Flexbox.Item>
            <Show when={ctx.hasNextStep()}>
                <Flexbox disabled={!currentStep().completed()} as="button" dir="horizontal" class={btnStyles.btn} data-type="primary" onClick={() => ctx.selectNextStep()}>
                    <span>Next</span>
                    <Icon src="fas fa-chevron-right" />
                </Flexbox>
            </Show>
            <Show when={!ctx.hasNextStep() && ctx.hasOnComplete} >
                <Flexbox as="button" dir="horizontal" class={btnStyles.btn} data-type="primary" onClick={() => ctx.onComplete!()}>
                    <span>Complete</span>
                    <Icon src="fas fa-chevron-right" />
                </Flexbox>
            </Show>
        </Flexbox.Item>
        <Flexbox.Item auto />
        <Show when={!!ctx.onCancel}>
            <Flexbox.Item>
                <Flexbox as="button" dir="horizontal" class={btnStyles.btn} data-type="link" onClick={() => ctx.onCancel!()} >
                    <span>Cancel</span>
                </Flexbox>
            </Flexbox.Item>
        </Show>
    </Flexbox>
}
